import React from "react";
import Highlight, { defaultProps } from "prism-react-renderer";
import theme from "prism-react-renderer/themes/nightOwl";

function BlockCode(props) {
  const className = props.children[0].props.className || "language-js";
  const language = className.split("-")[1];

  return (
    <div class="my-4 ">
      <Highlight
        {...defaultProps}
        code={props.children[0].props.children[0].trim()}
        language={language}
        theme={theme}
      >
        {({ className, style, tokens, getLineProps, getTokenProps }) => (
          <div className="relative p-8 rounded-md bg-codeBlock">
            <pre className={className} style={style}>
              {/* <div className="absolute text-lg font-bold text-blue-100 right-4 top-4">
                {language.toUpperCase()}
              </div> */}
              {tokens.map((line, i) => (
                <div {...getLineProps({ line, key: i })}>
                  {line.map((token, key) => (
                    <span {...getTokenProps({ token, key })} />
                  ))}
                </div>
              ))}
            </pre>
          </div>
        )}
      </Highlight>
    </div>
  );
}

export default BlockCode;
